import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TbOption } from '@ascschool/interface/table/option';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'table-basic',
  templateUrl: './table-basic.component.html',
  styleUrls: ['./table-basic.component.scss']
})
export class TableBasicComponent implements OnInit, AfterViewInit {
  myPipe: any;
  myPipeArgs: any;
  dataList: any;
  isLoading: boolean;
  @Input() options: TbOption; // lấy danh sách options
  @Input() // lấy data asyn
  set data(value) {
    this.isLoading = true;
    setTimeout(() => {
      this._data.next(value);
      this.isLoading = false;
    }, 500);
  }
  get data() {
      return this._data.getValue();
  }
  height : number;
  //sự kiện trả về
  @Output() pageIndexEvent = new EventEmitter(); // sự kiện trả về khi đổi page table
  @Output() pageSizeEvent = new EventEmitter(); // sự kiện trả về khi đổi kích cỡ page
  @Output() edit = new EventEmitter(); // sự kiện trả về khi nhấn nút sửa
  @Output() delete = new EventEmitter(); // sự kiện trả về khi nhấn nút xóa
  @Output() info = new EventEmitter(); // sự kiện trả về khi nhấn nút thông tin
  @Output() arrangeClass = new EventEmitter();
  @Output() passwordRecovery = new EventEmitter();
  @Output() listCheckedId = new EventEmitter(); // sự kiện trả về danh sách Id checked
  @Output() listCheckedItem = new EventEmitter(); // sự kiện trả về danh sách Item checked
  @ViewChild('pageHeaderTable', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content;
    }
  }
  @ViewChild('Table', { static: false }) tableElement: NzTableComponent;
  private elementPageHeaderTable: ElementRef;
  heightHeader = 0;
  keys = [];
  lengthCol: number;
  widthBntCol: number;
  private _data = new BehaviorSubject([]);

  constructor(
    public sizePageService: SizePageService,
  ) { }

  ngOnInit() { 
    this.loadData();
    this.lengthCol = this.options.columns.length;
    if (this.options.isBtnCol){
      this.widthBntCol = 25 + (15 * this.checkNumberBtn());
    }
  }
  ngAfterViewInit(){
    if (this.options.isScrollTable === true){
      this.heightHeader = this.elementPageHeaderTable.nativeElement.offsetHeight;
      this.height =  this.options.height - this.heightHeader
      setTimeout(() => {
        this.heightHeader = this.elementPageHeaderTable.nativeElement.offsetHeight;
      }, 10);
    }
  }
  loadData(){
    this._data.subscribe(() => { 
      this.dataList = this.data;
    });
  }
  pageSizeHanlder(event){
    this.pageSizeEvent.emit(event);
  }
  pageIndexHanlder(event){
    this.pageIndexEvent.emit(event);
  }
  isIndexLeft(i: number){
    if (this.options.isIndexCol === true){
      return i + 1;
    }else{
      return i;
    }
  }
  isIndexRight(i: number){
    if (this.options.isBtnCol){
      return this.lengthCol - i + 1;
    }else{
      return this.lengthCol - i;
    }
  }
  deleteHanlder(item: any){
    this.delete.emit(item);
  }
  infoHanlder(item: any){
    this.info.emit(item);
  }
  editHanlder(item: any){
    this.edit.emit(item);
  }
  arrangeClassHanlder(item: any){
    this.arrangeClass.emit(item);
  }
  passwordRecoveryHanlder(item: any){
    this.passwordRecovery.emit(item);
  }
  checkNumberBtn(){
    let i = 0;
    if (this.options.isBtnCol){
      if (this.options.isDeleteBtn){
        i += 1;
      }
      if (this.options.isInfoBtn){
        i += 1;
      }
      if (this.options.isEditBtn){
        i += 1;
      }
      if (this.options.isArrangeClassBtn){
        i += 1;
      }
      if (this.options.isPasswordRecoveryBtn){
        i += 1;
      }
      return i;
    }
  }
  checked = false;
  indeterminate = false;
  listOfCurrentPageData = [];
  setOfCheckedId = new Set<number>();
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
    this.listCheckedId.emit(this.setOfCheckedId);
    this.listCheckedItem.emit(this.listOfCurrentPageData);
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
}
